var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreciseFast = function SvgPreciseFast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.778 34.94 6.76-13.162h-5.982v-8.89l-7.009 13.334h6.23zm.23 9.06q-4.149 0-7.801-1.574t-6.354-4.274q-2.701-2.7-4.277-6.347Q4 28.155 4 24.007t1.574-7.8 4.274-6.354 6.347-4.277Q19.845 4 23.993 4t7.8 1.574 6.354 4.274 4.277 6.347Q44 19.845 44 23.993q0 4.148-1.574 7.8t-4.274 6.354-6.347 4.277Q28.155 44 24.007 44M24 41.778q7.445 0 12.611-5.167T41.778 24 36.61 11.389Q31.445 6.222 24 6.222T11.389 11.39 6.222 24t5.167 12.611Q16.555 41.778 24 41.778"
  })));
};
export default SvgPreciseFast;